import { useEffect, useState } from "react";
import axios from "axios";
import { format } from "timeago.js";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContex";
import * as timeago from "timeago.js";
import pt_BR from "timeago.js/lib/lang/pt_BR";

export default function Post({ post }) {
  timeago.register("pt_BR", pt_BR);
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;

  const { user: currentUser } = useContext(AuthContext);

  const [gosto, setLike] = useState(post.likes.length);
  const [isLiked, setIsLiked] = useState(false);
  const likeHandler = () => {
    try {
      axios.put("post/" + post._id + "/gostar", {
        userId: currentUser._id,
      });
    } catch (err) {}

    setLike(isLiked ? gosto - 1 : gosto + 1);
    setIsLiked(!isLiked);
    if (isDesgosto) {
      setDesgosto(desgosto - 1);
      setIsDesgosto(!isDesgosto);
    }
  };

  const [desgosto, setDesgosto] = useState(post.dislikes.length);
  const [isDesgosto, setIsDesgosto] = useState(false);
  const desgostoHandler = () => {
    try {
      axios.put("post/" + post._id + "/des/gostar", {
        userId: currentUser._id,
      });
    } catch (err) {}

    setDesgosto(isDesgosto ? desgosto - 1 : desgosto + 1);
    setIsDesgosto(!isDesgosto);
    if (isLiked) {
      setLike(gosto - 1);
      setIsLiked(!isLiked);
    }
  };

  const [user, setUser] = useState({});
  useEffect(() => {
    const fetchUser = async () => {
      const res = await axios.get(`usuarios?userId=${post.userId}`);
      setUser(res.data);
    };
    fetchUser();
  }, [post.userId]);

  return (
    <>
      <div className="card">
        <div className="card-body pb-1">
          <div className="d-flex">
            <Link to={`perfil/${user.username}`}>
              <img
                className="me-2 rounded"
                src={
                  user.imagemProfil
                    ? PS + "users/" + user.imagemProfil
                    : PS + "users/noavatar.jpg"
                }
                alt="Generic placeholder image"
                height="32"
              />
            </Link>

            <div className="w-100">
              <div className="dropdown float-end text-muted">
                <a
                  className="dropdown-toggle arrow-none card-drop"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {/* <i className="mdi mdi-dots-horizontal"></i>-+ */}
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a className="dropdown-item">Editar</a>

                  <a className="dropdown-item">Eliminar</a>
                </div>
              </div>
              <h5 className="m-0">{user.username}</h5>
              <p className="text-muted">
                <small>
                  {format(post.createdAt, "pt_BR")}
                  <span className="mx-1">⚬</span>
                </small>
              </p>
            </div>
          </div>

          <hr className="m-0" />

          <div className="my-3">
            <p>{post.desc}</p>
            <div className="row">
              <div className="col-12">
                <img
                  src={PS + "posts/" + post.img}
                  alt=""
                  className="rounded me-1 mb-3 mb-sm-0 img-fluid"
                />
              </div>
            </div>
          </div>

          <div className="mt-1 mb-1">
            <a
              onClick={likeHandler}
              className="btn btn-sm btn-rounded btn-outline-warning text-muted"
            >
              💰 {gosto}
            </a>
            <a
              onClick={desgostoHandler}
              className=" btn btn-sm btn-rounded btn-outline-danger text-muted"
            >
              👎 {desgosto}
            </a>

            <a className="btn btn-sm btn-link text-muted">
              <i className="uil uil-share-alt"></i> partilhar
            </a>
          </div>
          <hr className="m-0" />

          {/* <div className="mt-3">
            <div className="d-flex mb-2">
              <img
                src={PS + "users/noavatar.jpg"}
                height="32"
                className="align-self-start rounded me-2"
                alt="Arya Stark"
              />
              <div className="w-100">
                <input
                  type="text"
                  className="form-control border-0 form-control-sm"
                  placeholder="Wr"
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}
